import { useEffect, useState, useRef } from "react";
import { fetchArrivals } from "../lib/api";

export default function useFetchArrivals(systemId, stopId, refreshMs = 30000) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const intervalRef = useRef();

  useEffect(() => {
    if (!systemId || !stopId) return;
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const arrivals = await fetchArrivals(systemId, stopId);
        if (!cancelled) setData(arrivals);
      } catch (err) {
        if (!cancelled) setError(err.message);
      }
      if (!cancelled) setLoading(false);
    }
    load();
    intervalRef.current = setInterval(load, refreshMs);
    return () => {
      cancelled = true;
      clearInterval(intervalRef.current);
    };
  }, [systemId, stopId, refreshMs]);

  return { data, loading, error };
} 